import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCogs, faBell, faList, faTimes } from '@fortawesome/free-solid-svg-icons';
import parse from "html-react-parser";
import { LoadingSpinnerModal } from '../../components/dab';
import { Card, CardBody, CardImg, CardLink, CardText, CardTitle, Col, Row, CardFooter, Fade, Container, Input, Button } from "reactstrap";
import { messageBoardAction } from '../../actions/messageBoardAction';
import NoImage from '../../assets/images/noimage.png'
import { showAlert } from "../common/functions";
import { useHistory } from 'react-router-dom'

interface IFourmsProps {
	dispatch: Dispatch<any>;
	messageBoardData: any;
}

const Forums: React.SFC<IFourmsProps> = ({
	dispatch, messageBoardData }) => {

	const history = useHistory();

	const initialFilterValues = {
		isActive: true,
		isInActive: false
	};

	const [isAllMessagesAdded, setIsAllMessagesAdded] = useState(false);
	const [messageBoardList, setMessageBoardList] = useState([]);
	const [filterInput, setFilterInput] = useState(initialFilterValues);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [filterFlag, setIsFilterFlag] = useState(false);
	const [isRestore, setIsRestore] = useState(false);

	const handeToggle = () => setFadeIn(!fadeIn);

	React.useEffect(() => {
		dispatch(messageBoardAction.messageBoardGetByFilter());

		var fromPage = sessionStorage.getItem("fromPage");

		if (fromPage && fromPage.trim().toLowerCase() === 'messageboard') {
			handleFilterRestore();
		}		
	}, [])

	const handleFilterRestore = () => {
		var filter = sessionStorage.getItem("msgFilter");
		if (filter != null && filter.trim() != "") {
			var filterObj = JSON.parse(filter.toString());
			if (filterObj != null) {
				setFilterInput(filterObj);
				setIsRestore(true);
				sessionStorage.removeItem("fromPage");
				sessionStorage.removeItem("msgFilter");
			}
		}
	}

	const handleFilter = (type, value, checked) => {
		var input = filterInput;
		var messageBoardListToFilter = messageBoardData.allMessagesData;

		if (type == "status") {
			if (value == "active") {
				input.isActive = checked;
			}
			else {
				input.isInActive = checked;
			}
		} else if (type === "restore") {
			input.isActive = value.isActive
			input.isInActive= value.isInActive
		}

		setFilterInput(input);		
		
		if (input.isActive == false && input.isInActive == false) {
			messageBoardListToFilter = [];
			setIsFilterFlag(!filterFlag);
		}
		else if (input.isActive == true && input.isInActive == false) {
			messageBoardListToFilter = messageBoardListToFilter.filter(data => {
				return (
					data.isActive == true
				);
			});
			setIsFilterFlag(!filterFlag);
		}
		else if (input.isActive == false && input.isInActive == true) {
			messageBoardListToFilter = messageBoardListToFilter.filter(data => {
				return (
					data.isActive == false
				);
			});
			setIsFilterFlag(!filterFlag);
		}

		setMessageBoardList(messageBoardListToFilter);	
		if (initialFilterValues.isActive != filterInput.isActive || initialFilterValues.isInActive != filterInput.isInActive) {
			setShowClearFilter(true)
		} else {
			setShowClearFilter(false)
		}
	};

	const handleClearFilter = () => {
		setFadeIn(false);
		sessionStorage.removeItem("fromPage");
		sessionStorage.removeItem("msgFilter");
		setFilterInput(initialFilterValues);
		setShowClearFilter(false);
		var messageBoardListToFilter = messageBoardData.allMessagesData.filter(data => {
			return (
				data.isActive == true
			);
		});
		setMessageBoardList(messageBoardListToFilter);
	}

	if (messageBoardData && messageBoardData.isSuccess && !messageBoardData.isError) {
		if (messageBoardData.isAllMessagesLoaded && !isAllMessagesAdded) {
			if (messageBoardData.allMessagesData && messageBoardData.allMessagesData.length > 0) {
				setIsFilterFlag(!filterFlag);
				setIsAllMessagesAdded(true);				
				if (isRestore) {
					handleFilter("restore", filterInput, true);
				} else {
					handleFilter("status", "inActive", false);
				}
			}
		}
	}

	if (messageBoardData && messageBoardData.isError && !messageBoardData.isSuccess) {
		messageBoardData.isError = false;
		if (messageBoardData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(messageBoardData.status, true);
		}
	}

	const handleDetailNavigation = () => {
		if (initialFilterValues.isActive != filterInput.isActive || initialFilterValues.isInActive != filterInput.isInActive) {
			sessionStorage.setItem("fromPage", "messageboard")
			sessionStorage.setItem("msgFilter", JSON.stringify(filterInput));
		}		
	}

	return (
		<div className="forum-list">
			<div className="card-box">				
				<Row className='filter-link-container'>
					<Col lg="8" className='column'><CardLink onClick={handeToggle} className='card-box-link'>Filter List</CardLink>
						{showClearFilter ?
							<CardLink onClick={handleClearFilter} className='card-box-link-filter'>Clear Filter</CardLink>
								: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}
					</Col>
					<Button data-testid="createNewMsgBoard" id="submit" className="btn-submit-frm new-mb"
						onClick={() => { window.location.href = "/messageboard?page=add"; }}>Create New</Button>
				</Row>
				{fadeIn && (
					<Fade in={fadeIn} tag="h5" className='card-fade'>
						<Row>
							<Col lg="3">
						<Container className='filter-container'>
							<div className='box-container'>
								<Row>
									<Col lg="8">
										<div>
											<label>Status</label>
											<div className='filterRow'>
												<Input type="checkbox" className='box-container-input' checked={filterInput.isActive}
													onChange={(e) => { handleFilter("status", "active", e.target.checked) }} />
												<span> Active</span>
											</div>
											<div className='filterRow'>
												<Input type="checkbox" className='box-container-input' checked={filterInput.isInActive}
													onChange={(e) => { handleFilter("status", "inactive", e.target.checked) }} />
												<span> Inactive</span>
											</div>
										</div>
									</Col>
									<Col lg="4">
										<div className='close-div'>
											<FontAwesomeIcon data-bs-toggle="tooltip" data-bs-placement="bottom" size='3x'
												title="Close" icon={faTimes} onClick={handeToggle} />
										</div>
									</Col>
								</Row>
							</div>
							</Container>
							</Col>
						</Row>
					</Fade>)}
			</div>
			<div>
				<Row data-testid="msgBoardListRow" xs="3">
					{messageBoardList && messageBoardList.length <= 0 &&
							<Col data-testid={'msgBoardListCol'} lg="12" className="loader">
								<h4> No data found </h4>
							</Col>
					}
					{messageBoardList && (messageBoardList).map((data: any) =>
						<Col data-testid={'msgBoardListCol'} key={data.messageBoardId} lg="4">
							<Card data-testid={'msgBoardListCard' + data.messageBoardId} className={data.isActive ? 'card-box' : 'card-box-disabled'} >
								<CardLink data-testid="msgBoardListCardImgLink" className='card-box-link-title'
									href={'/messageboard?page=topics&id=' + data.messageBoardId}
									title={data.title} onClick={handleDetailNavigation}>
										<CardImg data-testid="msgBoardListCardImg" className='card-box-img'
										src={ data.iconImageUrl}
										alt="test"
										onError={(e: any) => { e.target.src = NoImage }}
									/>
								</CardLink>
								<CardBody data-testid="msgBoardListCardBody" className={data.isActive ? 'card-body' : 'card-body-disabled'}>
									<CardTitle data-testid="msgBoardListCardTitle" tag="h5">
										<CardLink data-testid={"msgBoardListCardLink" + data.messageBoardId}  className='card-box-link-title'
											href={'/messageboard?page=topics&id=' + data.messageBoardId}
											title={data.title} onClick={handleDetailNavigation}>
											{data.title} 
										</CardLink>
									</CardTitle>
									<CardText tag={'div'} data-testid="descriptionLink">
										{parse(data.descriptionHtml)}
									</CardText>
								</CardBody>
								<CardFooter className='card-footer'>
									<Row xs="3" key="test" className='card-footer-row'>
										<Col lg="4" xl="4" xs="4" md="4" className='footer-box'>
											<CardLink data-testid={"msgBoardListViewTopicLink" + data.messageBoardId} className='card-box-link-title'
												href={'/messageboard?page=topics&id=' + data.messageBoardId} 
												title="View Topics" onClick={handleDetailNavigation}>
												<FontAwesomeIcon data-testid={"msgBoardListViewTopic" + data.messageBoardId} size='2x'
													className='footer-box-icon' icon={faList}
													data-bs-toggle="tooltip" data-bs-placement="bottom" title="View Topics"/>
											</CardLink>
										</Col>
										<Col lg="4" xl="4" xs="4" md="4" className='footer-box'>
											<CardLink data-testid={"msgBoardListViewAlert" + data.messageBoardId} className='card-box-link-title'
												href={'/messageboard?page=alerts&id=' + data.messageBoardId}
												title="View Alerts" onClick={handleDetailNavigation}>
												<FontAwesomeIcon data-testid={"msgBoardListViewAlertIcon" + data.messageBoardId} size='2x'
													className='alert-icon' icon={faBell}
													data-bs-toggle="tooltip" data-bs-placement="bottom" title="View Alerts" />
												{data.alertCount > 0 ?
													<span className='badge'>{data.alertCount}</span> :
													""}
											</CardLink>
										</Col>
										<Col lg="4" xl="4" xs="4" md="4" className='footer-box-last'>
											<CardLink data-testid="msgBoardDetailLink" className='card-box-link-title'
												href={'/messageboard?page=detail&id=' + data.messageBoardId}
												onClick={handleDetailNavigation} title="View Details">
													<FontAwesomeIcon data-testid={"msgBoardListViewDetail" + data.messageBoardId} size='2x'
														className='detail-icon' icon={faCogs}
														data-bs-toggle="tooltip" data-bs-placement="bottom" title="View Details"
												/>
											</CardLink>
										</Col>
									</Row>
								</CardFooter>
								<Row key="viewreport" className='card-footer-row card-footer'>
									<CardTitle tag="h5" className='card-title-bottom' >
										<CardLink data-testid={"msgBoardListViewReport" + data.messageBoardId} className='footer-box-bottom'
											href={"/messageboard?page=reports&id=" + data.messageBoardId} title="View Report" onClick={handleDetailNavigation}>
											View Statistics
										</CardLink>
									</CardTitle>
								</Row>
							</Card>
						</Col>
					)}
					</Row>				
			</div>
			{messageBoardData.isLoading && (<LoadingSpinnerModal isShowModal={messageBoardData.isLoading} modalChange={(value:any)=>value} />)}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { messageBoardData } = state;
	return {
		messageBoardData
	};
};

export default connect(mapStateToProps)(Forums);